import AppMenuItem from "./AppMenuItem/AppMenuItem"
import useStyles from "./styles"
import { mobileBreakpoint } from "../../lib/helper/viewportHelper"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { strings as Localization } from "../../lib/Localization"
import theme from "../../theme"
import {
    Box, Button, IconButton, List, Typography, useMediaQuery
} from "@material-ui/core"
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos"
import CloseIcon from "@material-ui/icons/Close"
import React, { useEffect, useMemo, useState } from "react"
// TODO: Refactorera! Fett oklart vad som går fel men allt som ser konstigt ut är här enligt principen "dont fix what aint broken" och it aint broken :/
// https://medium.com/@modularcoder/reactjs-multi-level-sidebar-navigation-menu-with-typescrip-materialui-251943c12dda
const Menu2 = ({
    toggleDrawer, onItemClick, history, makeHistory
}) => {
    const classes = useStyles()
    const [collectionStructure, setCollectionStructure] = useState(null)
    const [loading, setLoading] = useState(false)
    const lang = useLanguage()
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint))
    const [currentCollection, setCurrentCollection] = useState({ collections: [] })
    const activeCollection = useMemo(() => (isMobile ? currentCollection.collections : collectionStructure?.collections), [currentCollection, isMobile, collectionStructure])

    const fetchCollectionStructure = async () => {
        setLoading(true)
        const response = await fetch(`/api/Collections/GetCollectionHierarchy?language=${lang}`)
        setLoading(false)
        return await response.json()
    }

    const getHistoryFromCollection = collection => {
        let res = [collection]
        let current = collection
        while (current.parent) {
            res = [current.parent, ...res]
            current = current.parent
        }
        return res
    }

    const selectCollection = collection => {
        setCurrentCollection(current => ({ ...collection, parent: current }))
    }

    useEffect(() => {
        fetchCollectionStructure().then(result => {
            setCollectionStructure(result)
            setCurrentCollection({ ...result, parent: null })
        })
    }, [])

    useEffect(() => {
        makeHistory(getHistoryFromCollection(currentCollection))
    }, [currentCollection])

    return (
        activeCollection && currentCollection && collectionStructure
            ? (
                <>
                    <div>
                        <Box style={{
                            display: "flex", flexDirection: "row", justifyContent: isMobile ? "space-between" : "flex-end", alignItems: "center"
                        }}
                        >
                            <Button style={{ display: isMobile ? "block" : "none" }} onClick={() => { setCurrentCollection(current => current?.parent ?? current); if (history.length == 1) toggleDrawer() }}>{Localization.back}</Button>
                            <IconButton onClick={() => { toggleDrawer(); makeHistory(null) }}><CloseIcon /></IconButton>
                        </Box>

                        <Box style={{ display: "flex", paddingLeft: "16px" }} onClick={() => { setCurrentCollection(current => current?.parent ?? current) }}>
                            <Typography
                                component={Box}
                                style={{ display: "flex", alignItems: "center" }}
                                variant="h6"
                                width="fit-content"
                            >
                                <ArrowBackIosIcon style={{ display: currentCollection.id != collectionStructure.id ? "block" : "none", fontSize: "1rem" }} />
                                {currentCollection.name}
                            </Typography>
                        </Box>
                    </div>
                    {
                        (loading && collectionStructure.collections.length <= 0)
                    && (
                        <Typography>
                            {Localization.loading}
                            ...
                        </Typography>
                    )
                    }
                    <List component="nav" className={classes.appMenu} disablePadding>
                        {
                            activeCollection.map((collection, i) => {
                                if (collection !== undefined) {
                                    return (
                                        <AppMenuItem
                                            key={i}
                                            id={collection.id}
                                            name={collection.name}
                                            collections={collection.collections}
                                            selectCollection={selectCollection}
                                            indent={0}
                                            onItemClick={onItemClick}
                                            makeHistory={makeHistory}
                                        />
                                    )
                                }
                            })
                        }
                    </List>
                </>
            )
            : ""
    )
}

export default Menu2
